// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import get from 'lodash/get'
import { i18n } from '../../index'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import StationPage from '../station/StationPage'
import ThumbableServicePage from './ThumbableServicePage'
import type { ThumbableService } from './thumbableServiceTypes'
import { fetchStationThumbableServices } from './thumbableServiceQueries'

const StationThumbableServicePage = () => (
  <StationPage title={i18n.t('admin.stations.title.thumbableServices')}>
    {({ station }) => (
      <Query<
        {
          thumbsUpItems: Array<ThumbableService>
        },
        Record<string, any>
      >
        query={fetchStationThumbableServices}
        variables={{
          stationId: station.id,
        }}
      >
        {({ loading, error, data }) => (
          <Loader
            {...{
              loading,
              error,
            }}
          >
            <ThumbableServicePage
              data={get(data, 'stationThumbsUpItems', [])}
              variables={{
                stationId: station.id,
              }}
              stationId={station.id}
            />
          </Loader>
        )}
      </Query>
    )}
  </StationPage>
)

export default StationThumbableServicePage
